<template>
  <div class="s-treeview">
    <label class="s-treeview-search" v-if="item && item.searchable" for="filter-search">
      <i class="ico ico-search" v-if="!isSearching"></i>
      <input type="search" :placeholder="'Rechercher dans ' + item.content" id="filter-search" @keyup="onKeyup($event)" @keydown="onKeydown($event)" v-model="search">
      <div class="s-loader" v-if="isSearching"></div>
    </label>
    <ul class="s-treeview-list">
      <p class="s-treeview-empty" v-if="items.length === 0 && search !== ''">{{ Translator('front.search.no_results') }}</p>
      <li class="s-treeview-item" v-for="el in items" :key="el.id">
        <Treeview-item
          :level="level + 1"
          :item="el"
          :opened="opened"
          :displayedMore="displayedMore"
          :selected="selected"
          v-on:open="onToggleOpen"
          v-on:select="onSelect" />
      </li>
      <li v-if="item && hasShowMore() && items.length > 0">
        <button type="button" @click="onShowMore()" class="color-accent s-treeview-more">
          <span class="s-treeview-spacer" v-for="i in level + 1" :key="i"></span>
          {{ Translator('front.search.show_more') }}...
          <span class="s-loader" v-if="isSearching"></span>
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
import debounce from 'debounce';
import FacetsService from '@/front/services/facets';

export default {
  name: 'NewTreeview',
  data: () => ({
    search: '',
    isSearching: false
  }),
  props: {
    level: {
      default: 0
    },
    item: {
      default: null
    },
    items: {
      required: true
    },
    displayedMore: {
      required: true
    },
    opened: {
      required: true
    },
    selected: {
      required: true
    },
  },
  created() {
    this.onSearch = this.onSearch.bind(this);
    this._onUpdateFacets = this._onUpdateFacets.bind(this);
    this.onSearch = debounce(this.onSearch, 600);
  },

  mounted() {},

  methods: {
    hasShowMore() {
      if( this.item.facetCount > this.item.children.length ) return true;
      return false;
    },

    onKeydown(pEvt) {
      if(this.isSearching) pEvt.preventDefault();
    },

    onKeyup() {
      let search = this.search.trim();
      if( search !== this.search ) return;
      this.search = search;
      if(this.isSearching) return;
      this.onSearch();
    },

    onShowMore() {
      if(this.isSearching) return;
      this.isSearching = true;
      this.onSearch(true);
    },

    onSearch(nextPage = false) {
      this.isSearching = true;
      const lastChild = this.item.children[ this.item.children.length - 1 ];
      const nextId = nextPage ? lastChild.id : null;
      this.item.search = this.search;
      FacetsService.filter( this.item.id, this.search, nextId ).then( res => {
        if( nextPage ) {
          this.item.children.push(...res.data.data);
        } else {
          const items = res.data.data;
          const loaded = FacetsService.loadedFacets;
          items.forEach(item => {
            for( let i = this.opened.length - 1; i >= 0; i--) {
              if(this.opened[i].id === item.id) {
                this.opened.splice(i, 1);
                break;
              }
            }
            for( let i = loaded.length - 1; i >= 0; i--) {
              if(loaded[i] === item.id) {
                FacetsService.loadedFacets.splice(i, 1);
                break;
              }
            }
          });
          this.item.children = items;
        }
        if(nextPage && this.item.children.length === 0) this.item.hasChildren = false;
        this.item.facetCount = res.data.facetCount;
        this.isSearching = false;
      })
    },

    onToggleOpen(pEvt) {
      this.$emit('open', pEvt);
    },

    onSelect() {
      this.$emit('select', this.selected);
    },

    _onUpdateFacets() {
      this.isSearching = false;
      this.search = null;
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
<style scoped lang="scss">
  .viewer-element {
    .s-treeview {
      @include vertical-spacing-bottom(.5);
      padding-top: rem(5);
      .s-treeview-spacer {
        display: block;
        flex-shrink: 0;
        width: rem(20);
      }
      .s-treeview {
        margin-bottom: 0 !important;
      }
      .s-loader {
        @include loader($black, .5);
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: rem(30);
        height: rem(30);
        pointer-events: none;
        display: block;
      }
      .s-treeview-empty {
        text-align: center;
        font-style: italic;
        font-size: rem(14);
      }
      .s-treeview-list {
        @include resetList;
        padding-bottom: rem(10);
      }
      .s-treeview-more {
        @include resetBtn;
        position: relative;
        display: flex;
        padding: rem(5);
        font-size: rem(14);
        &:hover, &:focus-visible {
          text-decoration: underline;
        }
      }
      .s-treeview-search {
        display: block;
        position: relative;
        margin-left: rem(30);
        border: rem(1) solid $grey-light;
        border-radius: rem(6);
        height: rem(30);
        margin-bottom: rem(5);
        input {
          padding-left: rem(30);
          height: 100%;
          width: 100%;
        }
        .ico {
          position: absolute;
          top: 50%;
          left: rem(10);
          transform: translateY(-50%);
        }
      }
    }
  }
</style>